import { Chart } from 'chart.js/auto';

export interface YearValueMap {
  [year: string]: number;
}

export function RenderChart(jsonData: YearValueMap, title: string, canvasId = 'chartCanvas'): void {
  const sortedKeys = Object.keys(jsonData).sort();
  const values = sortedKeys.map((key) => jsonData[key]);

  // Destroy existing chart if it exists
  const existingChart = Chart.getChart(canvasId);
  if (existingChart) {
    existingChart.destroy();
  }

  const canvas = document.getElementById(canvasId) as HTMLCanvasElement | null;
  const ctx = canvas?.getContext('2d');
  if (!ctx) {
    return;
  }

  new Chart(ctx, {
    type: 'line',
    data: {
      labels: sortedKeys,
      datasets: [
        {
          label: title,
          data: values,
          borderColor: 'rgba(54, 162, 235, 1)',
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          fill: true,
          tension: 0.3,
        },
      ],
    },
    options: {
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: title,
          font: { size: 18 },
        },
        legend: {
          display: false,
        },
      },
      scales: {
        y: {
          beginAtZero: false,
          ticks: {
            callback: (value) => Number(value).toLocaleString(),
          },
        },
      },
    },
  });
}
